import {
  backDropDiv,
  closeIcon,
  errorBanner,
  okBtn,
  locationIdErrorBanner,
  warningBanner,
  outageBanner,
  outageBannercloseIcon,
} from "../constants/elements";
export const startError = (errors: any, metaData: any): void => {
  // backDropDiv.className = "retail-error-banner-background";
  backDropDiv.style.display = "block";
  let errorResp: any;
  if (errors && errors.length > 0) {
    errorResp = errors[0]?.messages[0];
  }
  const locationId = new URLSearchParams(window.location.search).get("locationId");
  const locRespAddress1 = document.querySelector("[rsmonitor='location_response_addr1']");
  const locRespAddress1Value = locRespAddress1?.getAttribute("value");
  if (errorResp && errorResp.indexOf("appointment slot unavailable") !== -1) {
    warningBanner.style.display = "flex";
    // const warningBanner: any = document.getElementById("goToDateAndTimePage");
    // if (warningBanner) {
    //   warningBanner.style.display = "flex";
    // }
    backDropDiv.style.display = "retail-error-banner-background";
  } else if (metaData.stepName && metaData.stepName.toLowerCase() === "launch screen") {
    if (!locationId || !locRespAddress1Value || locRespAddress1Value === "") {
      locationIdErrorBanner.style.display = "flex";
    } else if (errorResp && errorResp.indexOf("isOutageBannerEnabled")) {
      outageBanner.style.display = "flex";
    }
  } else if (!locationId) {
    locationIdErrorBanner.style.display = "flex";
  } else {
    errorBanner.style.display = "flex";
  }
  if (closeIcon) {
    closeIcon.addEventListener("click", function () {
      errorBanner.style.display = "none";
      backDropDiv.style.display = "none";
    });
  }
  if (outageBannercloseIcon) {
    outageBannercloseIcon.addEventListener("click", function () {
      outageBanner.style.display = "none";
      backDropDiv.style.display = "none";
    });
  }
  if (okBtn) {
    okBtn.addEventListener("click", function () {
      warningBanner.style.display = "none";
      const timeAndDatePage: any = document.getElementById("goToDateAndTimePage");
      timeAndDatePage.click();
    });
  }
};
